import React, { useContext } from "react";
import { FaHeart } from "react-icons/fa";

import { MdOutlineShoppingCart } from "react-icons/md";
import { Link, NavLink } from "react-router-dom";
import { MObilehandelrContext } from "./Mobilehandelr";
import { CartProvider } from "./CartContext";

function Navbar() {
  let { cartitem } = useContext(CartProvider);
  let { isMobile, openmenu, setopenmenu } = useContext(MObilehandelrContext);
  return (
    <nav className="Navbar">
      <div className="Container">
        <div className="logo">
          <img src=".\images\logo.png" alt="" />
        </div>
        <ul>
          <NavLink to={"/"}>Home</NavLink>
          <NavLink to={"/About"}>About</NavLink>
          <NavLink to={"/shop"}>Shop</NavLink>
          <NavLink to={"/contact"}>Contact</NavLink>
        </ul>
        <div className="nav--icons">
          <div className="nav--icon">
            <span>0</span>
            <FaHeart />
          </div>
          <Link to={"/AddCart"} className="nav--icon">
            <span>{cartitem.length}</span>
            <MdOutlineShoppingCart />
          </Link>
        </div>
        {/* menu-open */}
        {isMobile && (
          <div
            className={`nav--baricon ${openmenu ? "menu-open" : ""}`}
            onClick={() => setopenmenu(!openmenu)}
          >
            <div></div>
            <div></div>
          </div>
        )}
      </div>
    </nav>
  );
}

export default Navbar;
